module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "titleplage"
  }, [_c('p', {
    staticClass: "immagine3"
  }, [_c('span', [_vm._v("Elena Ferrante")])]), _vm._v(" "), _c('p', {
    staticClass: "immagine4"
  }, [_c('span', [_vm._v("THE LOST DAUGHTER")])]), _vm._v(" "), _c('p', {
    staticClass: "immagine2",
    attrs: {
      "id": "traduzione"
    }
  }, [_c('span', [_c('i', [_vm._v("Translated from the Italian"), _c('br'), _vm._v("\n    by Ann Goldstein")])])]), _vm._v(" "), _c('div', {
    staticClass: "immagine"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "92",
      "src": "Images/logo.jpg",
      "width": "98"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2929d977","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Titlepage.vue
// module id = 66
// module chunks = 0